import React from 'react';
import type { ReactElement } from 'react';
import { useFormContext } from 'react-hook-form';
import Card from 'atom-components/card';
import FormButtonsContainer from 'atom-components/form-buttons-container';
import SubmitButton from 'atom-components/form-fields-for-hook-form/submit-button';
import type { BaseTag } from 'services/assist-api/entities/tag/tags';
import AttentionReasons from './attention-reasons';
import Comment from './comment';
import FlagForAttention from './flag-for-attention';
import { SubmitAction } from './mark-response-form.schema';

const fieldName = 'submitAction';

type Props = {
  attentionReasons: BaseTag[];
  canEditMark: boolean;
  canAdministrateMark: boolean;
  isSaving: boolean;
};

export default function MarkSubmission({
  attentionReasons,
  canEditMark,
  canAdministrateMark,
  isSaving
}: Props): ReactElement {
  const { formState, setValue, watch } = useFormContext();
  const { isSubmitting } = formState;
  const submittingOrSaving = isSubmitting || isSaving;
  const saveDraftButtonDisabled = submittingOrSaving || !canEditMark;
  const submitMarkingButtonDisabled = submittingOrSaving || (!canAdministrateMark && !canEditMark);
  const submitAction = watch(fieldName);

  return (
    <Card>
      <Card.Header>
        <Card.Heading level={3}>Mark Submission</Card.Heading>
      </Card.Header>
      <Card.Body>
        <FlagForAttention canEditMark={canEditMark} />
        <AttentionReasons canEditMark={canEditMark} attentionReasons={attentionReasons} />
        <Comment canEditMark={canEditMark} />
        <FormButtonsContainer>
          <SubmitButton
            disabled={saveDraftButtonDisabled}
            onClick={(): void => {
              setValue(fieldName, SubmitAction.SaveDraftMarking);
            }}
          >
            {submittingOrSaving && submitAction === SubmitAction.SaveDraftMarking
              ? 'Saving Draft...'
              : 'Save Draft Marking'}
          </SubmitButton>
          <SubmitButton
            disabled={submitMarkingButtonDisabled}
            onClick={(): void => {
              setValue(fieldName, SubmitAction.SubmitMarking);
            }}
          >
            {submittingOrSaving && submitAction === SubmitAction.SubmitMarking
              ? 'Submitting Mark...'
              : 'Submit Marking'}
          </SubmitButton>
        </FormButtonsContainer>
      </Card.Body>
    </Card>
  );
}
